import { render, staticRenderFns } from "./ControlComponent.vue?vue&type=template&id=0fffd4c7&scoped=true&"
import script from "./ControlComponent.vue?vue&type=script&lang=js&"
export * from "./ControlComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fffd4c7",
  null
  
)

export default component.exports